import {useCallback, useEffect} from 'react';
import {useFetchStatus} from '@/hooks/use-fetch-status';
import {useAuth} from '@/services/auth';
import {useAppStore} from '@/services/store';
import {logger} from '@/utils/logger';
import {prepareUserData} from './utils/prepare-user-data';

export const useUser = () => {
  const {user, setUser} = useAppStore();
  const {getUser} = useAuth();
  const {isLoading, setLoadingStatus, isFailed, setFailStatus} =
    useFetchStatus();

  const getUserData = useCallback(async () => {
    setLoadingStatus(true);

    try {
      const userData = await getUser();
      setLoadingStatus(false);
      setUser(prepareUserData(userData));
    } catch (error) {
      setFailStatus();
      logger.error(error);
    } finally {
      setLoadingStatus(false);
    }
  }, [getUser, setFailStatus, setLoadingStatus, setUser]);

  useEffect(() => {
    if (!user && !isFailed && !isLoading) {
      getUserData().catch(logger.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFailed, isLoading, user]);

  return {user, loading: isLoading, isFailed};
};
